import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { SharedIcon } from "./shared-icon";

const Dialog = DialogPrimitive.Root;

const DialogTrigger = DialogPrimitive.Trigger;

const DialogPortal = DialogPrimitive.Portal;

const DialogClose = DialogPrimitive.Close;

const DialogTitle = DialogPrimitive.Title;

const DialogOverlay = ({ className, ...props }) => (
  <DialogPrimitive.Overlay
    className={`react-modal-overlay${className ? ` ${className}` : ""}`}
    {...props}
  />
);
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;

const DialogContent = React.forwardRef(
  ({ className, children, ...props }, ref) => (
    <DialogPortal>
      <DialogOverlay />
      <DialogPrimitive.Content
        ref={ref}
        className={`react-modal-content${className ? ` ${className}` : ""}`}
        {...props}
      >
        {children}
        <div>
          <DialogPrimitive.Close className="react-modal-close-button">
            <div className="react-modal-close-button-icon-wrapper">
              <SharedIcon iconName="#sprite-icon-cross" />
            </div>
          </DialogPrimitive.Close>
        </div>
      </DialogPrimitive.Content>
    </DialogPortal>
  )
);
DialogContent.displayName = DialogPrimitive.Content.displayName;

export {
  Dialog,
  DialogPortal,
  DialogOverlay,
  DialogClose,
  DialogTrigger,
  DialogContent,
  DialogTitle,
};
